<p-dialog [(visible)]="exibeFiltros" [style]="{width: '600px'}" header="Filtros" [modal]="true" styleClass="p-fluid"
  (onHide)="hideDialog()">
  <ng-template pTemplate="content">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label>Cód. Dealer:</label>
        <input type="text" pInputText placeholder="Informe o Cód Dealer..." [(ngModel)]="filtros.codDealer"/>
      </div>
      <div class="p-field p-col-12">
        <label>Nome:</label>
        <input type="text" pInputText placeholder="Informe o Nome..." [(ngModel)]="filtros.nome"/>
      </div>
      <div class="p-field p-col-12">
        <label>CNPJ:</label>
        <p-inputMask mask="99.999.999/9999-99" [(ngModel)]="filtros.cnpj" placeholder="CNPJ do Dealer..." unmask="true"></p-inputMask>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton label="Limpar" icon="pi pi-trash" class="p-button-text" (click)="limpafiltros()"></button>
    <button pButton label="Filtrar" icon="pi pi-check" class="p-button-text" (click)="enviarFiltros()"></button>
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
  </ng-template>
</p-dialog>
